const axios = require('axios');
var querystring = require('querystring');
import firebase from 'firebase'
export default {
    data() {
        return {
          token:null,
          url:'https://api.khanbank.com/v1/',
          username:'AfyaDOcrPesBGCSkA3GKPsZ68ZsMucsb',
          password:'sNsNmD3AsAA7FCgP',
          data:null
        };
    },
    methods: {
        async _getToken(){
            var basicAuth = 'Basic ' + btoa(this.username + ':' + this.password);
            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization':  basicAuth,
                'Access-Control-Allow-Origin': '*',
             
                // 'Access-Control-Allow-Origin': '*',
                // 'Access-Control-Allow-Headers': 'Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers, Access-Control-Allow-Methods, access-control-allow-methods',
                // "Access-Control-Allow-Credentials": "true",
                // "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
            }
            try{
                // response =await axios.post(this.url+"auth/token", querystring.stringify({'grant_type':'client_credentials'}), {
                //     crossdomain: true,
                //     headers: headers,
                // });
                // console.log(response);
                var publish = firebase.functions().httpsCallable('calltokenapi');
                var response=await publish(
                    { 
                        url: this.url+"auth/token",
                        headers:JSON.stringify(headers) ,
                        type:'post',
                        body: querystring.stringify({'grant_type':'client_credentials'})
                    }
                );
                this.data=response.data;
                return response;
            }
            catch(e){
                
            }
            return  null;
        },
        async _getAccount(){
            if(!this.data || (this.data && !this.data.access_token))
                await this._getToken();
            const headers = {
                'Authorization':  "Bearer "+this.data.access_token,
            }
            var publish = firebase.functions().httpsCallable('callapi');
            var response=await publish(
                { 
                    url: this.url+"accounts",
                    headers:JSON.stringify(headers) ,
                    type:'get',
                    body: querystring.stringify({'name':'111'})
                }
            );
            return response.data;
            
        }
        ,
        async _getDefaultTransaction(accountNumber){
            if(!this.data || (this.data && !this.data.access_token))
                await this._getToken();
            const headers = {
                'Authorization':  "Bearer "+this.data.access_token,
            }
            var publish = firebase.functions().httpsCallable('callapi');
            var response=await publish(
                { 
                    url: this.url+"statements/"+accountNumber,
                    headers:JSON.stringify(headers) ,
                    type:'get',
                    body: querystring.stringify({'name':'111'})
                }
            );
            return response.data;
            
        }
        ,
        async _getFilterTransaction(accountNumber, start, end){
            if(!this.data || (this.data && !this.data.access_token))
                await this._getToken();
            const headers = {
                'Authorization':  "Bearer "+this.data.access_token,
            }
            var publish = firebase.functions().httpsCallable('callapi');
            var response=await publish(
                { 
                    url: this.url+"statements/"+accountNumber+"?from="+start+"&to="+end,
                    headers:JSON.stringify(headers) ,
                    type:'get',
                    body: querystring.stringify({'name':'111'})
                }
            );
            return response.data;
            
        }
    },
    
}
